import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './CookiesPolicyPage.css';

const CookiesPolicyPage = () => {
  return (
    <div className="cookies-policy-page">
      <SEO 
        title="Política de Cookies"
        description="Política de Cookies da AASPS. Saiba como utilizamos cookies no nosso website."
        url="/politica-cookies"
      />
      <Header />
      
      {/* Hero Section */}
      <div className="cookies-hero">
        <div className="cookies-hero-content">
          <h1>Política de Cookies</h1>
        </div>
      </div>
      
      <main className="cookies-content">
        <div className="cookies-container">
          
          <h2>Informação sobre os ficheiros de cookies</h2>

          <h3>O que é um cookie?</h3>
          <p>
            Um cookie é um pequeno ficheiro de texto que um website coloca no seu computador, telefone ou outro dispositivo com acesso à internet, contendo informação relativa à navegação efetuada nesse website.
          </p>
          <p>
            Os cookies retêm apenas informação associada às suas preferências, não recolhendo dados pessoais sem o seu consentimento.
          </p>

          <h3>Para que servem os ficheiros de cookies?</h3>
          <p>
            Os cookies facilitam e simplificam a navegação, tornando-a mais rápida e eficiente. Contribuem para melhorar a experiência do utilizador e evitam a necessidade de introduzir repetidamente as mesmas informações.
          </p>
          <p>
            Os cookies não danificam o dispositivo e têm como principal finalidade garantir o correto funcionamento do website e otimizar a utilização das suas funcionalidades.
          </p>

          <h2>Tipos de cookies</h2>
          <p>Os cookies podem ser classificados de acordo com três critérios: ciclo de vida, domínio e finalidade.</p>

          <h3>Quanto ao ciclo de vida</h3>
          <ul>
            <li><strong>Cookies Persistentes:</strong> Mantêm-se armazenados no dispositivo durante um período definido pelo cookie.</li>
            <li><strong>Cookies de Sessão:</strong> São temporários e eliminados automaticamente quando fecha o navegador.</li>
          </ul>

          <h3>Quanto ao domínio</h3>
          <ul>
            <li><strong>Cookies Próprios (first party):</strong> São enviados pelo website que está a visitar e pertencem ao domínio da AASPS.</li>
            <li><strong>Cookies de Terceiros (third party):</strong> São enviados por websites externos cujo conteúdo pode estar integrado na página da AASPS (ex.: mapas, vídeos, ferramentas analíticas).</li>
          </ul>

          <h3>Quanto à finalidade</h3>
          
          <h4>a) Cookies Estritamente Necessários</h4>
          <p>
            Essenciais para o funcionamento do website. Permitem ações como definir preferências de privacidade, iniciar sessão ou preencher formulários. Não podem ser desativados nos nossos sistemas. Não armazenam informação pessoal identificável.
          </p>

          <h4>b) Cookies de Funcionalidade</h4>
          <p>
            Permitem memorizar escolhas do utilizador (ex.: idioma, sessão iniciada). Melhoram funcionalidades e personalização da experiência. Se desativados, algumas funções poderão não operar corretamente.
          </p>

          <h4>c) Cookies de Marketing</h4>
          <p>
            Utilizados para construir perfis com base nos seus interesses e exibir anúncios relevantes no nosso website ou noutros. Funcionam por identificação única do browser e do dispositivo, não recolhendo dados pessoais. Se desativados, deixará de visualizar publicidade personalizada.
          </p>

          <h4>d) Cookies Estatísticos (Analíticos)</h4>
          <p>
            Permitem medir visitas, tráfego e desempenho do website. Ajudam a identificar páginas mais ou menos visitadas e analisar padrões de utilização. As informações recolhidas são agregadas e anónimas.
          </p>
          <p>
            Se desativados, não saberemos como utiliza o site, prejudicando a melhoria contínua.
          </p>

          <h4>e) Cookies Não Classificados</h4>
          <p>
            Cookies cuja categorização está a ser analisada juntamente com os respetivos fornecedores.
          </p>

          <h2>É possível desativar a utilização de cookies?</h2>
          <p>
            Sim. Pode desativar cookies nas definições do seu navegador. No entanto, essa ação poderá afetar o correto funcionamento de algumas funcionalidades do website.
          </p>
          <p>
            A configuração dos cookies é geralmente efetuada no menu "Preferências", "Definições" ou "Ferramentas" do navegador. Para detalhes adicionais, consulte o menu "Ajuda" do seu navegador.
          </p>

          <h2>Alterações à Política de Cookies</h2>
          <p>
            A AASPS reserva-se o direito de alterar, atualizar ou ajustar a presente Política de Cookies sempre que necessário, em conformidade com a legislação aplicável. Recomendamos a consulta regular desta página para se manter informado.
          </p>

          <h2>Mais informação</h2>
          <p>
            Para obter mais informações sobre cookies, a sua gestão ou a proteção da sua privacidade, poderá também consultar a nossa <a href="/politica-privacidade">Política de Privacidade</a>, disponível no website da AASPS.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CookiesPolicyPage;
